export default "__VITE_ASSET__DaES3Vra__"